import { Router } from '@angular/router';
import { DatabaseService } from './database/database.service';
import { ConnectionService, ConnectionState } from 'ng-connection-service';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth/auth.service';
import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import { ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { BackgroundSyncService } from '@app/helpers/backgroundSync.service';

@Component( {
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: [ './app.component.scss' ],
} )
export class AppComponent implements OnInit {
  title = 'Provincia ART ML';
  environmentName = '';
  environmentUrl = 'Debug api';
  userIsLogged: any;
  myTimerOffline: any;




  constructor( private titleService: Title,
               private http: HttpClient,
               private router: Router,
               private authService: AuthService,
               private connectionService: ConnectionService,
               private backgroundSyncService: BackgroundSyncService,
               private databaseService: DatabaseService,
               private config: PrimeNGConfig,
               private translateService: TranslateService,

  ) {
    this.databaseService.updateOnlineStatusOnOfflineDB( true );
    localStorage.setItem( 'isStillOnline', 'true' );

    this.environmentName = environment.environmentName;
    this.environmentUrl = environment.apiUrl;

    if ( !environment.production ) {
      this.setDocTitle( environment.environmentName );
    }

    this.authService.currentUser.subscribe( ( x ) => {
      this.userIsLogged = x;
      const actualPath = location.pathname;
      if ( this.userIsLogged && actualPath === '/login' ) {
        router.navigate( [ 'examenes' ] );
      }
    } );

    localStorage.setItem('cargadosIsFirstSearch', 'true');

  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    localStorage.removeItem('cargadosIsFirstSearch');
  }

  ngOnInit(): void {
    this.translateService.setDefaultLang( 'es' );
    this.translate( 'es' );
    window.addEventListener( 'keyup', disableF5 );
    window.addEventListener( 'keydown', disableF5 );

    function disableF5( event: any ): void {
      if ( ( event.which || event.keyCode ) === 116 ) {
        event.preventDefault();
      }
    }

    this.connectionService.monitor().subscribe( ( connected: ConnectionState ) => {
      const isConnected = connected.hasNetworkConnection;
      console.log( 'App en estado ' + isConnected );
      this.databaseService.updateOnlineStatusOnOfflineDB( isConnected );
      this.backgroundSyncService.checkPorEnviarTableChange( isConnected );

      if ( isConnected ) {
        localStorage.setItem( 'isStillOnline', 'true' );

      } else {
        if (JSON.parse(localStorage.getItem('cargadosIsFirstSearch'))) {
          this.databaseService.cleanTable('examenesCargados');
          this.databaseService.cleanTable('examenesPresentismoPorEnviar');
        }
        localStorage.setItem( 'isStillOnline', 'false' );

        const usersOfflineActual = JSON.parse(localStorage.getItem('offlineUsers'));
        const today = new Date();
        const expiraDateNuevo =  this.addDays(today, 5);
        console.log('NUEVO EXPIRA ' + expiraDateNuevo)

        if (usersOfflineActual) {

          const usersOffline = {
            usuarios: usersOfflineActual.usuarios,
            expirationDate: expiraDateNuevo,
            api: usersOfflineActual.api
          };
          this.databaseService.updateUsuariosOnOfflineDB(usersOffline.usuarios);
          this.databaseService.updateOfflineUsersOnOfflineDB(usersOffline);
          localStorage.setItem("offlineUsers", JSON.stringify(usersOffline));
        }
        this.myTimerOffline = setInterval(()=> {this.timerOffline()}, 1500000);
      }
    } );
  }

  setDocTitle( title: string ): void {
    console.log( 'current title:::::' + this.titleService.getTitle() );
    this.titleService.setTitle( title );
  }

  translate( lang: string ): void {
    this.translateService.use( lang );
    this.translateService.get( 'primeng' ).subscribe( ( res ) => {
      this.config.setTranslation( res );
    } );
  }

  public timerOffline():void{
    const usersOffline = JSON.parse(localStorage.getItem('offlineUsers'));
    const isOnline = JSON.parse(localStorage.getItem('isStillOnline'));
    const actualPath = location.pathname;

    console.log('Ingresar timerOffline' + new Date());

    if (actualPath !== '/login' &&  !isOnline) {

    const expirationDate = usersOffline.expirationDate;
    const today = new Date();
    const expirationDateTime = new Date(expirationDate);

    if (today.getTime() > expirationDateTime.getTime()) {
      this.router.navigate(['login']);
      clearInterval(this.myTimerOffline);

      localStorage.removeItem( 'offlineUsers' );
      // this.databaseService.deleteItemFromTable( 1, 'currentUser' );
      // this.databaseService.deleteItemFromTable( 1, 'offlineUsers' );

      this.authService.logout();
    }
  }

  }

  private addDays(date, days) {
        date.setDate(date.getDate() + days);
        return date;
  }

}
